import moment from "moment";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { Button, Checkbox, Icon, Modal, Pagination } from "semantic-ui-react";
import LeavHistoryForm from "../../components/LeaveHistoryForm";
import LeaveManagementTable from "../../components/LeaveManagementTable";
import { exportFileAction } from "../../core/actions/commonAction";
import {
    clearMessageModal,
    getLeaveTypeList,
    getListRequest,
    getSummaryOfLeave,
    updateConfirm,
} from "../../core/actions/myLeaveRequestAction";
import functionCommon from "../../core/common/function";
import { commonConstants } from "../../core/constant/common.constants";
import { leaveStatusLabel } from "../../core/constant/myLeaveRequest.constants";
import "./styles.scss";

const initialParams = {
    leaveType: { sortBy: "id-ASC" },
    summaryOfLeave: {
        sortBy: "leaveTypeId-ASC",
        pageRecord: 100,
        currentPage: 1,
    },
    listRequest: {
        isSearch: 0,
        dayFrom: moment().startOf("month").format("DD-MM-YYYY"),
        dayTo: moment().endOf("month").format("DD-MM-YYYY"),
        leaveTypeId: "",
        status: "",
        sortBy: "status-ASC",
        pageRecord: 20,
    },
};

export default function MyLeaveRequest() {
    const { t } = useTranslation();
    const history = useHistory();
    const dispatch = useDispatch();
    const myLeaveStore = useSelector((state) => state.myLeaveRequestReducer);
    const { loadingPage, errorCode, confirming, searching } = myLeaveStore;
    const [sumaryData, setSummaryData] = useState({
        requested: [],
        available: [],
        isCarriedOver: 0,
        availableTime: 0,
    });
    const [listRequest, setListRequest] = useState([]);
    const [listLeaveType, setListLeaveType] = useState([]);
    const [searchCondition, setSearchCondition] = useState(initialParams.listRequest);
    const conditionRef = useRef(initialParams.listRequest);
    const [currentPage, setCurrentPage] = useState(1);
    const [message, setMessage] = useState(null);
    const [messageModal, setMessageModal] = useState(null);
    const [isOpenModal, setIsOpenModal] = useState(false);
    const [isDisableCheckbox, setIsDisableCheckbox] = useState(true);
    const [dataError, setDataError] = useState({
        day: null,
    });

    const handleGoToAdd = () => {
        history.push(`/my-leave-request/new-leave-request`);
    };

    const handleGoToDetail = (id) => () => {
        history.push(
            `/my-leave-request/detail?leaveRequestId=${id}&hasPermission=${commonConstants.HAS_PERMISSION.MY_DETAIL_REQUEST}`
        );
    };

    const handleConfirm = () => {
        dispatch(updateConfirm());
    };

    const summaryOfLeaveProcess = (rawData) => {
        // Processing data load to summary of leave table
        if (rawData && rawData.length > 0) {
            const requested = [];
            const available = [];
            const typeCount = ["1", "2", "3", "4", "5"];
            let availableTime = 0;
            let isCarriedOver = 0;
            rawData
                .filter((ele) => Number(ele.leaveTypeId) !== 6) // Don't show data have id = 6
                .forEach((item) => {
                    requested.push([item.leaveTypeName, item.totalRequestedDays, Number(item.totalRequestedHours)]);
                    available.push([item.leaveTypeName, item.totalAvailableDays, Number(item.totalAvailableHours)]);
                    if (typeCount.indexOf(String(item.leaveTypeId)) >= 0) {
                        if (item.availableTime)
                            availableTime = parseInt(availableTime) + parseInt(Number(item.availableTime) * 100);
                        isCarriedOver = item.is_carriedOver;
                    }
                });
            setSummaryData({
                requested: requested,
                available: available,
                availableTime: availableTime / 100,
                isCarriedOver: isCarriedOver,
            });
        }
    };

    const getLableStatus = (status) => {
        if (status && leaveStatusLabel[status]) return t("labels." + leaveStatusLabel[status].toLowerCase());
    };

    const handleChangeModal = (value) => () => {
        setIsOpenModal(value);
    };

    const leaveHistoryProcess = (rawData) => {
        // Pocessing data load to requested table
        if (rawData && rawData.length > 0) {
            const listRequest = [];
            rawData.forEach((ele) => {
                const dateFormTo = `${moment(ele.dateFrom).format("DD/MM/YYYY")} - ${moment(ele.dateTo).format(
                    "DD/MM/YYYY"
                )}`;
                const { leaveTypeName, daysOff, hoursOff, aprroverName, status } = ele;
                listRequest.push([
                    <a className="leave-active-link" onClick={handleGoToDetail(ele.leaveRequestId)}>
                        {dateFormTo}
                    </a>,
                    leaveTypeName,
                    daysOff,
                    Number(hoursOff),
                    aprroverName,
                    status,
                ]);
            });

            setListRequest(listRequest);
            setMessage(null);
        } else {
            setListRequest([]);
            setMessage(t("message.018"));
            triggerMessage();
        }
    };

    const leaveTypeProcess = (rawData) => {
        // Process leave types
        if (rawData && rawData.length > 0) {
            const leaveTypes = [];
            rawData.forEach((ele) => {
                leaveTypes.push({
                    value: ele.leaveTypeId,
                    name: ele.leaveTypeName,
                });
            });
            setListLeaveType(leaveTypes);
        }
    };

    const handleGetSearchCondition = (conditions) => {
        setSearchCondition(conditions);
    };

    const handleSearch = () => {
        if (validateField()) {
            dispatch(getListRequest({ ...searchCondition, isSearch: 1, currentPage: 1 }, true));
            conditionRef.current = { ...searchCondition, isSearch: 1 };
            setCurrentPage(1);
        }
    };

    const downloadInstruction = () => {
        dispatch(
            exportFileAction(
                {
                    urlGetkey: "Leave/requestSecretKey",
                    urlDownfile: "Leave/downloadInstruction",
                },
                { secretKey: "" }
            )
        );
    };

    const triggerMessage = () => {
        setTimeout(() => {
            setMessage(null);
            dispatch(clearMessageModal());
        }, 2000);
    };

    const handlePaginationChange = (val) => {
        setCurrentPage(val);
        dispatch(getListRequest({ ...conditionRef.current, currentPage: val }, false, true));
    };

    const validateField = () => {
        const error = {};
        const formatDayFrom = searchCondition.dayFrom;
        const formatDayTo = searchCondition.dayTo;
        const dayFrom = new Date(moment(formatDayFrom, "DDMMYYYY ").local());
        const dayTo = new Date(moment(formatDayTo, "DDMMYYYY ").local());

        if (dayFrom > dayTo) {
            error.day = "message.040";
        } else {
            error.day = null;
        }
        setDataError(error);
        return !error.day;
    };

    useEffect(() => {
      const current = moment().format('YYYY-MM-DD');

      const dateSplit = current.split('-');
      if (dateSplit.length > 0) {
        const currentMonth = Number(dateSplit[1]);
        const currentDate = Number(dateSplit[2]);

        if (currentMonth === 3) {
          if (currentDate >= 1 && currentDate <= 31) setIsDisableCheckbox(false);
        }
      }
    }, []);

    useEffect(() => {
        if (errorCode) {
            setMessageModal(`message.${errorCode}`);
            triggerMessage();
        } else setMessageModal(null);
    }, [errorCode]);

    useEffect(() => {
        // Init call API
        dispatch(getLeaveTypeList(initialParams.leaveType));
        dispatch(getSummaryOfLeave(initialParams.summaryOfLeave));
        dispatch(getListRequest({ ...searchCondition, currentPage: currentPage }));
    }, []);

    useEffect(() => {
        const sumaryRawData = myLeaveStore.listSummary;
        summaryOfLeaveProcess(sumaryRawData);
    }, [myLeaveStore.listSummary]);

    useEffect(() => {
        const listRequest = myLeaveStore.listRequest.myLeaveRequestList;
        leaveHistoryProcess(listRequest);
    }, [myLeaveStore.listRequest]);

    useEffect(() => {
        const listLeaveType = myLeaveStore.listLeaveType;
        leaveTypeProcess(listLeaveType);
    }, [myLeaveStore.listLeaveType]);

    useEffect(() => {
        const error = {};
        setDataError(error);
    }, [searchCondition.dayFrom, searchCondition.dayTo]);

    const sumaryTable = useMemo(() => {
        return {
            requested: {
                subHeader: t("labels.totalRequestedTime"),
                header: [t("labels.leaveType"), t("labels.days"), t("labels.hours")],
                body: sumaryData.requested,
            },
            available: {
                subHeader: t("labels.totalAvailableTime"),
                header: [t("labels.leaveType"), t("labels.days"), t("labels.hours")],
                body: sumaryData.available,
            },
        };
    }, [sumaryData, t]);

    const historyTable = useMemo(() => {
        let listRender = [];
        if (listRequest.length > 0) {
            listRender = listRequest.map((ele) => {
                const item = [...ele];
                item[5] = getLableStatus(item[5]);
                return item;
            });
        }
        return {
            header: [
                t("labels.leaveDate"),
                t("labels.leaveType"),
                t("labels.daysOff"),
                t("labels.hoursOff"),
                t("labels.approver"),
                t("labels.status"),
            ],
            body: listRender,
        };
    }, [listRequest, t]);

    return (
        <div className="my-leave-request">
            <h2 className="page-heading">
                <span onClick={functionCommon.goToPage("/my-leave-request")}>{t("labels.leaveManagemnet")}</span>
                {"/ "}
                <span onClick={functionCommon.goToPage("/my-leave-request")}>{t("labels.myLeaveRequest")}</span>
            </h2>
            <div className="my-leave-btn-wrapper">
                <Button className="leave-button left" onClick={handleGoToAdd}>
                    {t("button.newLeaveRequest")}
                </Button>
                <Button className="leave-button" onClick={downloadInstruction}>
                    {t("labels.instruction")}
                </Button>
            </div>
            <div className="my-leave-sumary-wrapper">
                <p className="leave-title">{t("labels.sumaryOfLeave")}</p>
                <div className="sumary-table">
                    <LeaveManagementTable content={sumaryTable.requested} customTableClass="table-left" />
                    <LeaveManagementTable content={sumaryTable.available} customTableClass="table-right" />
                </div>
            </div>
            <div className="carried-over">
                <p className="content">
                    {t("labels.carriedOverNext")}: {sumaryData.availableTime} {t("labels.daysSpecial")}
                </p>
                <div className="confirm">
                    <Checkbox
                        label={t("labels.confirm")}
                        onClick={handleChangeModal(true)}
                        readOnly={isDisableCheckbox || Number(sumaryData.isCarriedOver) === 1}
                        disabled={isDisableCheckbox || Number(sumaryData.isCarriedOver) === 1}
                        checked={Number(sumaryData.isCarriedOver) === 1}
                    />
                </div>
            </div>
            <p className="carried-over-note">{t("labels.leaveYearNotify")}</p>
            <div className="my-leave-history-wrapper">
                <p className="leave-title">{t("labels.leaveHistory")}</p>
                <LeavHistoryForm
                    leaveTypeList={listLeaveType}
                    onChangeConditions={handleGetSearchCondition}
                    conditions={searchCondition}
                    onSearch={handleSearch}
                    isSearching={searching}
                    dataError={dataError}
                />
                <div className="history-table">
                    {message && <div className="error-message list-error-message">{message}</div>}
                    <LeaveManagementTable content={historyTable} className="table-custom" />
                    {myLeaveStore.listRequest.totalRecord > 0 && !searching && (
                        <div className="leave-table-paging">
                            <Pagination
                                size="tiny"
                                activePage={currentPage}
                                firstItem={null}
                                disabled={loadingPage}
                                lastItem={null}
                                totalPages={
                                    myLeaveStore.listRequest.totalPage > 0 ? myLeaveStore.listRequest.totalPage : null
                                }
                                prevItem={{
                                    disabled: currentPage === 1 || loadingPage,
                                    content: <Icon name="chevron left" />,
                                    icon: true,
                                }}
                                nextItem={{
                                    disabled: currentPage === myLeaveStore.listRequest.totalPage || loadingPage,
                                    content: <Icon name="chevron right" />,
                                    icon: true,
                                }}
                                onPageChange={(e, { activePage }) => handlePaginationChange(activePage)}
                            />
                        </div>
                    )}
                </div>
            </div>
            <Modal size="tiny" open={isOpenModal} onClose={handleChangeModal(false)}>
                <Modal.Header className="modal-header">
                    <p>{t("labels.confirm")}</p>
                    <p className="modal-close" onClick={handleChangeModal(false)}>
                        x
                    </p>
                </Modal.Header>
                <Modal.Content>
                    <p>{t("labels.confirmCarriedOver")}</p>
                    {messageModal && <div className="error-message list-error-message">{t(messageModal)}</div>}
                    <Button className="leave-button" disabled={confirming} onClick={handleConfirm}>
                        {confirming ? t("button.confirming") : t("labels.confirm")}
                    </Button>
                </Modal.Content>
            </Modal>
        </div>
    );
}
